// extracted by mini-css-extract-plugin
export default {"cardSec":"CertificateActivityLogs_cardSec__vyRJI","certificateImgSec":"CertificateActivityLogs_certificateImgSec__V9ByJ","downloadBtn":"CertificateActivityLogs_downloadBtn__geoXL"};